const DataMappingType = {
  BUSINESS_PARTNER_MAP_DELEGATE: 1,
  BUSINESS_PARTNER_MAP_USER_MANAGER: 2,
  DELEGATE_MAP_USER_MANAGER: 3,
};
export default DataMappingType;
